<template>
  <!-- Contenido del modal de INFO de una capa (presentación pura). El host calcula
       `info` (view-model ya formateado) y lo pasa por props; aquí solo se pinta.
       Es agnóstico a la métrica: en PROGRESO viene longitud (m) y en DISEÑO viene
       conteo de elementos — el host formatea `headlineValue` y `text` de cada fila. -->
  <div class="p-1">
    <!-- Resumen de la capa -->
    <div class="flex items-center gap-3 mb-5">
      <span class="w-5 h-5 rounded-[5px] flex-shrink-0 ring-1 ring-inset ring-black/10 shadow-sm"
        :style="{ backgroundColor: info.layerColor || '#cbd5e1' }"></span>
      <div class="min-w-0">
        <p class="text-base font-semibold text-gray-800 truncate" :title="info.layerName">{{ info.layerName }}</p>
        <p v-if="info.subtitle" class="text-xs text-gray-500">{{ info.subtitle }}</p>
      </div>
      <div class="ml-auto text-right flex-shrink-0">
        <p class="text-[11px] font-semibold uppercase tracking-wide text-gray-400">{{ info.headlineLabel }}</p>
        <p class="text-lg font-semibold text-[#3a6bc8]">{{ info.headlineValue }}</p>
      </div>
    </div>

    <!-- Desglose por estado (longitud en progreso, conteo en diseño) -->
    <p class="text-[11px] font-semibold uppercase tracking-wide text-gray-400 mb-2">
      {{ info.sectionTitle }}
    </p>

    <ul v-if="info.rows && info.rows.length" class="space-y-3">
      <li v-for="row in info.rows" :key="row.key">
        <div class="flex items-center gap-2 mb-1">
          <span class="w-3 h-3 rounded-sm flex-shrink-0 ring-1 ring-inset ring-black/10"
            :style="{ backgroundColor: row.color }"></span>
          <span class="text-sm text-gray-700 flex-1 min-w-0 truncate" :title="row.label">{{ row.label }}</span>
          <span class="text-sm font-medium text-gray-800">{{ row.text }}</span>
          <span class="text-xs text-gray-400 w-11 text-right">{{ row.pct }}%</span>
        </div>
        <div class="h-1.5 rounded-full bg-[#f2f2f7] overflow-hidden">
          <div class="h-full rounded-full transition-all"
            :style="{ width: Math.min(row.pct, 100) + '%', backgroundColor: row.color }"></div>
        </div>
      </li>
    </ul>

    <p v-else class="text-sm text-gray-400 py-4 text-center">
      {{ $t('no_progress_registered') }}
    </p>
  </div>
</template>

<script>
export default {
  name: "LayerInfoModal",

  props: {
    // View-model ya formateado:
    // { layerName, layerColor, subtitle, headlineLabel, headlineValue, sectionTitle,
    //   rows: [{ key, label, color, text, pct }] }
    info: { type: Object, required: true },
  },
}
</script>
